// This file contains constants related to workflows management meant to be consumed by the world
// outside the workflows slice

export const WorkflowsTabsIds = {
  v4: 'v4',
  v3: 'v3',
};
